module.exports = __webpack_public_path__ + "media/images/icon__point--lost@2x-9208df34c1b421cddfb7232b6e201438.png";